import React, { useState } from 'react'
import logo from '../images/logo.png'
import { Link } from 'react-scroll'
import { Link as MyLink } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'

const Header = () => {
  const [transition, setTransition] = useState('translate-x-full')
  const handleSideMenu = () => {
    transition === 'translate-x-full'
      ? setTransition('translate-x-0')
      : setTransition('translate-x-full')
  }

  return (
    <div>
      <div className='text-sm fixed top-0 z-50 flex flex-col'>
        <div className='fixed flex flex-col items-center bg-gray-50 md:mb-0 w-full'>
          <div
            style={{ color: '#212529' }}
            className='flex flex-row border-b-2 border-gray-100 items-center pl-0 py-4 justify-between w-full px-2 md:px-5 lg:px-24 xl:px-38 xxl:px-44'
          >
            <MyLink to='/'><img className='w-64' src={logo} alt='logo' /></MyLink>

            <div className='hidden md:flex font-bold justify-between xxl:mr-32'>
              <ul className='justify-start gap-x-5 items-center pl-2 flex flex-row font-bold'>
                <li className='group cursor-pointer flex flex-col w-max'>
                  <MyLink to='/' className='text-gray-700'>
                    HOME
                  </MyLink>
                  <div
                    className={`h-0.5 w-0 group-hover:w-full bg-blue-500 mx-auto transition-all duration-300 `}
                  ></div>
                </li>
                <li className='group cursor-pointer flex flex-col w-max'>
                  <HashLink
                    className='text-gray-700'
                    activeClass='active'
                    to='/#about'
                    spy
                    smooth
                    offset={-130}
                    duration={500}
                  >
                    ABOUT
                  </HashLink>
                  <div
                    className={`h-0.5 w-0 group-hover:w-full bg-blue-500 mx-auto transition-all duration-300 `}
                  ></div>
                </li>
                <li className='group cursor-pointer flex flex-col w-max'>
                  <HashLink
                    className='text-gray-700'
                    activeClass='active'
                    to='/#contact'
                    spy
                    smooth
                    offset={-130}
                    duration={500}
                  >
                    CONTACT US
                  </HashLink>
                  <div
                    className={`h-0.5 w-0 group-hover:w-full bg-blue-500 mx-auto transition-all duration-300 `}
                  ></div>
                </li>
                <li className='group cursor-pointer flex flex-col w-max'>
                <a href='https://www.mxwireless.com/shop'
                    className='text-gray-700'
                    activeClass='active'
                    to='accessories'
                    spy
                    smooth
                    offset={-130}
                    duration={500}
                  >
                    SHOP
                  </a>
                  <div className='h-0.5 bg-blue-500 mx-auto w-full transition-all duration-300'></div>
                </li>
                {/* <div className='flex justify-around mx-6 mt-20'> */}
                <li className='flex flex-col items-center'>
                  <i className='t text-2xl fab fa-facebook-f scale-105 hover:scale-150 transition-all duration-500'></i>
                </li>
                <li className='flex flex-col items-center'>
                  <i className='t text-2xl 	fab fa-twitter scale-105 hover:scale-150 transition-all duration-500'></i>
                </li>
                <li className='flex flex-col items-center'>
                  <i className='t text-2xl fa fa-instagram scale-105 hover:scale-150 transition-all duration-500'></i>
                </li>
                {/* </div> */}
              </ul>
            </div>
            <button onClick={() => handleSideMenu()} className='md:hidden'>
              <i className='fa fa-bars scale-150'></i>
            </button>
            <div
              className={`fixed h-screen w-4/5 sm:w-3/5 ${transition} bg-blue-500 md:hidden duration-500 ease-in-out transition-all right-0 text-gray-200 top-17`}
            >
              <div
                onClick={() => setTransition('translate-x-full')}
                className='bg-blue-500 absolute right-0 top-0 p-1 m-2 cursor-pointer'
              >
                <i className=' fa fa-close scale-105 float-right'></i>
              </div>
              <div className='flex justify-between mx-6 mb-6 mt-20'>
                <div className='flex flex-col items-center scale-125 hover:scale-150 transition-all duration-500 cursor-pointer'>
                  <p className='text-xs'>Search</p>
                  <i className='fa fa-search'></i>
                </div>
                <div className='flex flex-col items-center scale-125 hover:scale-150 transition-all duration-500 cursor-pointer'>
                  <p className='text-xs'>My Wishlist</p>
                  <i className='fa fa-heart'></i>
                </div>
                <div className='flex flex-col items-center scale-125 hover:scale-150 transition-all duration-500 cursor-pointer'>
                  <p className='text-xs'>My Cart</p>
                  <i className='fa fa-shopping-cart'></i>
                </div>
              </div>
              <ul className='flex flex-col gap-y-1 items-center'>
                <MyLink
                  to='/'
                  className='item pt-4 hover:border-b-2 font-bold transition-all duration-100 border-red-500'
                >
                  Home
                </MyLink>
                <li className='item pt-4 font-bold hover:border-b-2 transition-all duration-100 border-red-500'>
                  <Link activeClass='active' to='latest' spy smooth offset={-130} duration={500}>
                    Latest Items
                  </Link>
                </li>
                <li className='item pt-4 font-bold hover:border-b-2 transition-all duration-100 border-red-500'>
                  <Link
                    activeClass='active'
                    to='smartphones'
                    spy
                    smooth
                    offset={-130}
                    duration={500}
                  >
                    Smartphones
                  </Link>
                </li>
                <li className='item pt-4 font-bold hover:border-b-2 transition-all duration-100 border-red-500'>
                  <Link
                    activeClass='active'
                    to='accessories'
                    spy
                    smooth
                    offset={-130}
                    duration={500}
                  >
                    Accessories
                  </Link>
                </li>
                <li className='item pt-4 font-bold hover:border-b-2 transition-all duration-100 border-red-500'>
                  <Link activeClass='active' to='tablets' spy smooth offset={-130} duration={500}>
                    Tablet Phones
                  </Link>
                </li>
                <li className='item pt-4 font-bold border-b-2 transition-all duration-100 border-red-500'>
                  <Link activeClass='active' to='tablets' spy smooth offset={-130} duration={500}>
                    Shop
                  </Link>
                </li>
                {/* <li className='item pt-4 font-bold border-b-2 transition-all duration-100 border-red-500'>
                  <Link activeClass='active' to='tablets' spy smooth offset={-130} duration={500}>
                    Cart <i className='fa fa-shopping-cart'></i>
                  </Link>
                </li> */}
              </ul>
              <div className='flex justify-around mx-6 mt-20'>
                <div className='flex flex-col items-center'>
                  <i className='t text-2xl fab fa-facebook-f scale-125 hover:scale-150 transition-all duration-500'></i>
                </div>
                <div className='flex flex-col items-center'>
                  <i className='t text-2xl fab fa-linkedin-in scale-125 hover:scale-150 transition-all duration-500'></i>
                </div>
                <div className='flex flex-col items-center'>
                  <i className='t text-2xl 	fab fa-twitter scale-125 hover:scale-150 transition-all duration-500'></i>
                </div>
                <div className='flex flex-col items-center'>
                  <i className='t text-2xl fa fa-instagram scale-125 hover:scale-150 transition-all duration-500'></i>
                </div>
              </div>
            </div>
          </div>

          {/* Below is where the 2nd NavBar Border starts */}

          <div className='hidden w-full md:flex justify-center text-gray-200 border-b-2 border-gray-300 py-3 px-2 md:mx-5 lg:px-24 xl:px-38 xxl:px-44'>
            <ul className='justify-start items-center pl-2 flex flex-row font-bold'>
              <li className='group cursor-pointer pr-5 lg:pr-10 flex flex-col w-max'>
                <Link
                  className='text-gray-700 hover:text-blue-500'
                  activeClass='active'
                  to='smartphones'
                  spy
                  smooth
                  offset={-170}
                  duration={500}
                >
                  SMARTPHONES
                </Link>
                <div className='h-0.5 w-0 bg-red-500 mx-auto group-hover:w-full transition-all duration-300'></div>
              </li>
              <li className='group cursor-pointer pr-5 lg:pr-10 flex flex-col w-max'>
                <Link
                  className='text-gray-700 hover:text-blue-500'
                  activeClass='active'
                  to='latest'
                  spy
                  smooth
                  offset={-170}
                  duration={500}
                >
                  LATEST ITEMS
                </Link>
                <div className='h-0.5 w-0 bg-red-500 mx-auto group-hover:w-full transition-all duration-300'></div>
              </li>
              <li className='group cursor-pointer pr-5 lg:pr-10 flex flex-col w-max'>
                <Link
                  className='text-gray-700 hover:text-blue-500'
                  activeClass='active'
                  to='accessories'
                  spy
                  smooth
                  offset={-170}
                  duration={500}
                >
                  ACCESSORIES
                </Link>
                <div className='h-0.5 w-0 bg-red-500 mx-auto group-hover:w-full transition-all duration-300'></div>
              </li>
              <li className='group cursor-pointer pr-5 lg:pr-10 flex flex-col w-max'>
                <Link
                  className='text-gray-700 hover:text-blue-500'
                  activeClass='active'
                  to='tablets'
                  spy
                  smooth
                  offset={-170}
                  duration={500}
                >
                  TABLET PHONES
                </Link>
                <div className='h-0.5 w-0 bg-red-500 mx-auto group-hover:w-full transition-all duration-300'></div>
              </li>
              <li className='group cursor-pointer pr-5 lg:pr-10 flex flex-col w-max'>
                <h3 className='relative text-xl w-10 flex justify-center items-center h-10 text-blue-600'>
                  <i
                    className={`fa fa-shopping-cart scale-125 w-full h-full text-center flex items-center group-hover:scale-150 after:content-['0'] after:text-white after:text-xs after:rounded-full after:px-[5px] after:py-[0.5px] after:absolute after:top-0 after:right-1 after:bg-red-700 transition-all duration-500`}
                  ></i>
                </h3>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header
